<aa-popin-v3 [isShown]="isShown" [onClose]="onClosePopin" [width]="70" [backPic]="'zen'">
    <span class="title">Impersonation</span>
    <div class="popin-content-body">
        <div class="entities-list">
            <aa-impe-entities-list></aa-impe-entities-list>
        </div>
        <div class="users-list">
            <aa-impe-users-list></aa-impe-users-list>
        </div>
    </div>
    <div class="popin-content-footer">
        <aa-btn-action-secondary [disabled]="disabled | async" [btnText]="'BUTTON.IMPERSONATE.ENTER' | translate" [cta]="impersonate">
        </aa-btn-action-secondary>
        &nbsp;&nbsp;
        <aa-btn-action-transparent [btnText]="'BUTTON.IMPERSONATE.QUIT' | translate" (click)="quit()">
        </aa-btn-action-transparent>
    </div>
</aa-popin-v3>
